import { AudienceFilter, defineTopic } from 'magpie-lib/models';
import { tourMessages } from './tour.messages';
export const TOUR_TOPIC = '@nav-onboarding-tour/TOUR_TOPIC';
export const audienceFilter = AudienceFilter.builder().excludeSelf();
export const tourTopic = defineTopic({
  name: TOUR_TOPIC,
  messages: [tourMessages.startTour],
  enableRuntimeValidation: false,
  audience: audienceFilter.build()
});